import { render, staticRenderFns } from "./index.vue?vue&type=template&id=4330dd38&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=4330dd38&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4330dd38",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4330dd38')) {
      api.createRecord('4330dd38', component.options)
    } else {
      api.reload('4330dd38', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=4330dd38&scoped=true&", function () {
      api.rerender('4330dd38', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Charts/WordCloud/index.vue"
export default component.exports